import { render, staticRenderFns } from "./RegisterForm.vue?vue&type=template&id=580218e0&scoped=true"
import script from "./RegisterForm.vue?vue&type=script&lang=js"
export * from "./RegisterForm.vue?vue&type=script&lang=js"
import style0 from "./RegisterForm.vue?vue&type=style&index=0&id=580218e0&prod&lang=css"
import style1 from "./RegisterForm.vue?vue&type=style&index=1&id=580218e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580218e0",
  null
  
)

export default component.exports